import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL || "http://localhost:8001";

const api = axios.create({ baseURL: `${BASE}/api` });

const token = () => localStorage.getItem("ark_admin_token");
const authHeaders = () => ({ headers: { "x-admin-token": token() } });

// Auth
export const adminLogin = (username, password) =>
  api.post("/admin/login", { username, password }).then(r => r.data);

export const adminVerify = () =>
  api.get("/admin/verify", authHeaders()).then(r => r.data);

// Config
export const getConfig = () => api.get("/config").then(r => r.data);

// Services
export const getServices = () => api.get("/services").then(r => r.data);
export const createService = (data) =>
  api.post("/services", data, authHeaders()).then(r => r.data);
export const updateService = (id, data) =>
  api.put(`/services/${id}`, data, authHeaders()).then(r => r.data);
export const deleteService = (id) =>
  api.delete(`/services/${id}`, authHeaders()).then(r => r.data);

// Projects
export const getProjects = (category) =>
  api.get("/projects", { params: category ? { category } : {} }).then(r => r.data);
export const createProject = (data) =>
  api.post("/projects", data, authHeaders()).then(r => r.data);
export const updateProject = (id, data) =>
  api.put(`/projects/${id}`, data, authHeaders()).then(r => r.data);
export const deleteProject = (id) =>
  api.delete(`/projects/${id}`, authHeaders()).then(r => r.data);

// Team
export const getTeam = () => api.get("/team").then(r => r.data);
export const createTeamMember = (data) =>
  api.post("/team", data, authHeaders()).then(r => r.data);
export const updateTeamMember = (id, data) =>
  api.put(`/team/${id}`, data, authHeaders()).then(r => r.data);
export const deleteTeamMember = (id) =>
  api.delete(`/team/${id}`, authHeaders()).then(r => r.data);

// Testimonials
export const getTestimonials = () => api.get("/testimonials").then(r => r.data);
export const createTestimonial = (data) =>
  api.post("/testimonials", data, authHeaders()).then(r => r.data);
export const updateTestimonial = (id, data) =>
  api.put(`/testimonials/${id}`, data, authHeaders()).then(r => r.data);
export const deleteTestimonial = (id) =>
  api.delete(`/testimonials/${id}`, authHeaders()).then(r => r.data);

// Enquiries
export const getEnquiries = () =>
  api.get("/enquiries", authHeaders()).then(r => r.data);
export const createEnquiry = (data) =>
  api.post("/enquiries", data).then(r => r.data);
export const markEnquiryRead = (id) =>
  api.put(`/enquiries/${id}/read`, {}, authHeaders()).then(r => r.data);
export const deleteEnquiry = (id) =>
  api.delete(`/enquiries/${id}`, authHeaders()).then(r => r.data);

// Hero Images
export const getHeroImages = () => api.get("/hero-images").then(r => r.data);
export const createHeroImage = (data) =>
  api.post("/hero-images", data, authHeaders()).then(r => r.data);
export const updateHeroImage = (id, data) =>
  api.put(`/hero-images/${id}`, data, authHeaders()).then(r => r.data);
export const deleteHeroImage = (id) =>
  api.delete(`/hero-images/${id}`, authHeaders()).then(r => r.data);

// Stats
export const getStats = () =>
  api.get("/stats", authHeaders()).then(r => r.data);

// Seed
export const seedData = () =>
  api.post("/seed", {}, authHeaders()).then(r => r.data);
